import { takeLatest } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects'; // call, put, select, take
import createWebAPI from './WebAPI';
import createThrottler from './throttler';

const boughtKeywordThrottler = createThrottler({ delay: 2000 });

const GET_MORE_BOUGHT = 'user-dashboard/bought/GET_MORE_BOUGHT';
export const getMoreBought = (options = {}) => ({ type: GET_MORE_BOUGHT, options });

const CLEAR_BOUGHT = 'user-dashboard/bought/CLEAR_BOUGHT';
export const clearBought = () => ({ type: CLEAR_BOUGHT });

const SET_BOUGHT_LOADED = 'user-dashboard/bought/SET_BOUGHT_LOADED';
export const setBoughtLoaded = value => ({ type: SET_BOUGHT_LOADED, value });

const SET_BOUGHT_ALL_LOADED = 'user-dashboard/bought/SET_BOUGHT_ALL_LOADED';
export const setBoughtAllLoaded = value => ({ type: SET_BOUGHT_ALL_LOADED, value });

const LOAD_BOUGHT_PARTIAL_RESULT = 'user-dashboard/bought/LOAD_BOUGHT_PARTIAL_RESULT';
export const loadBoughtPartialResult = items => ({ type: LOAD_BOUGHT_PARTIAL_RESULT, items });

const SET_BOUGHT_KEYWORD_FILTER = 'user-dashboard/bought/SET_BOUGHT_KEYWORD_FILTER';
export const setBoughtKeywordFilter = value => ({ type: SET_BOUGHT_KEYWORD_FILTER, value });

const initialState = {
  bought: [],
  boughtPagesLoaded: 0,
  boughtToShow: 10,
  boughtAllLoaded: false,
  boughtLoaded: false,
  boughtKeywordFilter: '',
  previousBoughtKeywordFilter: '',
};

const webApi = createWebAPI();

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_BOUGHT_LOADED: {
      return { ...state, boughtLoaded: action.value };
    }
    case SET_BOUGHT_ALL_LOADED: {
      return { ...state, boughtAllLoaded: action.value };
    }
    case LOAD_BOUGHT_PARTIAL_RESULT: {
      if (action.items) {
        return { ...state, bought: state.bought.concat(action.items) };
      }
      return { ...state, bought: state.bought.concat([]) };
    }
    case CLEAR_BOUGHT: {
      return {
        ...state,
        bought: [],
        boughtPagesLoaded: 0,
        boughtAllLoaded: false,
      };
    }
    case SET_BOUGHT_KEYWORD_FILTER: {
      return {
        ...state,
        boughtKeywordFilter: action.value,
        previousBoughtKeywordFilter: state.boughtKeywordFilter,
      };
    }
    default:
      return state;
  }
}

export function sagas({ store }) {
  function* getMoreBoughtSaga(action) {
    try {
      const { boughtLoaded, boughtToShow, bought, boughtAllLoaded, boughtKeywordFilter } = yield select((state) => ({
        boughtLoaded: state.boughtModule.boughtLoaded,
        boughtToShow: state.boughtModule.boughtToShow,
        bought: state.boughtModule.bought,
        boughtAllLoaded: state.boughtModule.boughtAllLoaded,
        boughtKeywordFilter: state.boughtModule.boughtKeywordFilter,
      }));
      if (boughtLoaded && boughtAllLoaded) return;
      const params = {
        skip: bought.length,
        limit: boughtToShow,
      };
      if (boughtKeywordFilter && !action.options.ignoreKeyword) params.keyword = boughtKeywordFilter;

      yield put(setBoughtLoaded(false));
      const result = yield call(() => webApi.bought.getBoughtResources(params));

      if (result.length <= 0) {
        yield put(setBoughtAllLoaded(true));
      }
      yield put(loadBoughtPartialResult(result));
      yield put(setBoughtLoaded(true));
      if (result.length < boughtToShow) yield put(setBoughtAllLoaded(true));
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error('Exception in get more bought saga', ex);
    }
  }

  function* setBoughtKeywordFilterSaga() {
    const { boughtKeywordFilter, previousBoughtKeywordFilter } = yield select((state) => ({
      boughtKeywordFilter: state.boughtModule.boughtKeywordFilter,
      previousBoughtKeywordFilter: state.boughtModule.previousBoughtKeywordFilter,
    }));

    const deletedThirdChar = boughtKeywordFilter.length < 3 && previousBoughtKeywordFilter.length >= 3;
    const shouldCallApi = boughtKeywordFilter.length > 2 || deletedThirdChar;

    if (shouldCallApi) {
      boughtKeywordThrottler(() => {
        store.dispatch(clearBought());
        store.dispatch(getMoreBought({ ignoreKeyword: boughtKeywordFilter.length < 3 }));
      });
    }
  }

  return {
    * watchGetMoreBought() { yield* takeLatest(GET_MORE_BOUGHT, getMoreBoughtSaga); },
    * watchSetBoughtKeywordFilter() { yield* takeLatest(SET_BOUGHT_KEYWORD_FILTER, setBoughtKeywordFilterSaga); },
  };
}
